import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoggerProvider } from '@shared';
import { AppConfigService } from '../config/app-config.service';
import { EIDCProvider } from '../providers/oidc/eidc.provider';

/**
 * Runs before authGuard. On non-local environments, halts navigation and
 * triggers the EID authorize flow when the user is not authenticated,
 * so the app stays put while EIDCProvider performs the redirect.
 */
export const eidAuthorizationGuard: CanActivateFn = () => {
  const configService = inject(AppConfigService);
  const eidcProvider = inject(EIDCProvider);
  const logger = inject(LoggerProvider).createScoped('EidAuthorizationGuard');

  if (configService.isLocal()) {
    return true;
  }

  if (eidcProvider.isAuthenticated()) {
    return true;
  }

  logger.info('Not authenticated in EID, initiating authorize flow');
  return false;
};
